import type { MenuItemProps } from '@affine/component';
import { MenuItem } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { DeleteIcon } from '@blocksuite/icons/rc';

export const MoveToTrash = (props: MenuItemProps) => {
  const t = useI18n();

  return (
    <MenuItem
      prefixIcon={<DeleteIcon />}
      type="danger"
      data-ui-delete="document"
      {...props}
    >
      {t['com.streamlain.moveToTrash.title']()}
    </MenuItem>
  );
};
